'use client';
import React from 'react';
import SafetyReminderBanner from '@/components/SafetyReminderBanner';
import LandingFooter from '@/app/components/LandingFooter';

export default function SafetyAndFooter() {
  return (
    <>
      {/* Member Safety Reminder */}
      <div className="px-4 lg:px-6 xl:px-8 py-8">
        <div className="max-w-3xl mx-auto">
          <SafetyReminderBanner />
        </div>
      </div>

      {/* Full JSN Footer */}
      <LandingFooter />
    </>
  );
}
